export default "__VITE_ASSET__CU0sL_Ie__";